import type { ReactNode } from 'react';

export const symbol_call_missed: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M180-571v182q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-258q0-12.75 8.63-21.38Q137.25-677 150-677h251q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H219l266 266 293-293q9-9 21-8.5t21.39 9.5q8.61 9 8.61 21t-9 21L527-308q-9 9-20 13t-22 4q-11 0-22-4t-20-13L180-571Z"
		/>
	</svg>
);
